import { BaseConfig } from "../config.interface";
import { Size, Validate } from "../util";

interface IPasswordConfig {
    label?: string;
    autocomplete?: string;
    clear?: boolean;
    feedback?: boolean;
    toggleMask?: boolean;
    regex?: RegExp;
    maxlength?: string;
    size: Size | "full";
    validate: Validate;
}
export class PasswordConfig extends BaseConfig<IPasswordConfig> implements IPasswordConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Browser autocomplete attribute.
     */
    autocomplete?: string;
    /**
     * Show clear button.
     */
    clear?: boolean;
    /**
     * Show feedback message.
     */
    feedback?: boolean;
    /**
     * Allow mask to be toggleable.
     */
    toggleMask?: boolean;
    /**
     * Enforce value validation through a regex term.
     */
    regex?: RegExp;
    /**
     * Limit the max length of the value.
     */
    maxlength?: string;
    /**
     * Size of the input element.
     * @values "small" | "medium" | "large"
     */
    size: Size | "full";
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration. Use this for password input.
         * Has autocomplete value "current-password".
         */
        Default: new PasswordConfig({
            toggleMask:   true,
            clear:        true,
            autocomplete: "current-password",
            regex:        /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/,
            size:         "medium",
            validate:     "dirty"
        }),
        /**
         * Default configuration. Use this for password input.
         * Has autocomplete value "current-password".
         */
        Full: new PasswordConfig({
            toggleMask:   true,
            clear:        true,
            autocomplete: "current-password",
            regex:        /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/,
            size:         "full",
            validate:     "dirty"
        }),

        /**
         * Use this for new password input.
         * Has autocomplete value "new-password".
         */
        NewPassword: new PasswordConfig({
            toggleMask:   true,
            clear:        true,
            autocomplete: "new-password",
            feedback:     true,
            regex:        /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/,
            size:         "medium",
            validate:     "dirty"
        }),

        ConfirmPassword: new PasswordConfig({
            toggleMask:   true,
            clear:        true,
            autocomplete: "new-password",
            feedback:     false,
            size:         "medium",
            validate:     "dirty"
        }),
    };

}
